import {
  MessagePrimitive,
  type TextMessagePartComponent,
} from '@assistant-ui/react';
import {Pill} from '@wandb/components';
import React from 'react';

import {WANDB_DATA_PART_NAME} from '../../agentChat/messageConversions';
import type {ContentPart} from '../../agentChat/store';
import {useNightModeRevertFilter} from './useNightModeRevertFilter';
import {decodePromptForMessageDisplay} from './utils';

/** UserText renders plain text parts inside the user message bubble.
 * `decodePromptForMessageDisplay` handles legacy threads created
 * pre-prompt-parts API, which carry encoded mention markers
 * (e.g., {`run_id: "...", run_display_name: "..."}`).
 */
const UserText: TextMessagePartComponent = ({text}) => {
  const cleaned = decodePromptForMessageDisplay(text);

  if (cleaned === '') {
    return null;
  }

  return <span>{cleaned}</span>;
};

const WandbDataPart = ({data}: {data: ContentPart}) => {
  if (data.type !== 'wandb-run') {
    return null;
  }
  return (
    <Pill
      icon="running-repeat"
      textValue={data.runDisplayName ?? data.runName}
    />
  );
};

export const UserMessage = () => {
  const nightModeRevertFilter = useNightModeRevertFilter();

  return (
    <MessagePrimitive.Root
      className="flex flex-col items-end gap-10 pl-24 pt-16"
      data-role="user">
      <div className="relative max-w-full break-words overflow-hidden rounded-2xl px-16 py-8 text-moon-800 text-[15px] font-normal">
        <div
          className="absolute inset-0 rounded-2xl bg-moon-100 dark:bg-moon-750"
          style={{filter: nightModeRevertFilter}}
        />
        <div className="relative whitespace-pre-wrap [&_[data-component=Pill]]:align-middle">
          <MessagePrimitive.Parts
            components={{
              Text: UserText,
              data: {
                by_name: {
                  [WANDB_DATA_PART_NAME]: ({data}) => (
                    <WandbDataPart data={data as ContentPart} />
                  ),
                },
              },
            }}
          />
        </div>
      </div>
    </MessagePrimitive.Root>
  );
};
